import { Button, ButtonProps } from './Button';

type Props = ButtonProps;
export function ButtonGhost(props: Props) {
    return <Button {...props} variant="ghost" />;
}
